import styled from "styled-components";

import { Container } from "react-bootstrap";

import { theme } from "../../../styles/theme";

export const ContainerStyled = styled(Container)`
  height: 100vh;
  display: flex;
  max-width: 100vw;
  overflow: hidden;
  padding: 0 !important;
  background-color: ${theme.colors.blue900};
  flex-direction: row;

  @media screen and (max-width: 479px) {
    overflow-x: hidden;
    overflow-y: scroll;
    top: 0;
  }
`;
export const ContentStyled = styled(Container)`
  height: 100vh;
  display: flex;
  max-width: 100%;
  overflow: hidden;
  padding: 0 !important;
  flex-direction: column;

  @media screen and (max-width: 479px) {
    max-width: 80%;
    overflow-y: scroll;
  }
`;

export const CenterContent = styled.div`
  margin: 0 2rem;
  height: calc(100% - 100px);
  display: block;

  @media screen and (max-width: 479px) {
    margin: 0 8px;
  }
`;
